import React from 'react';
import { Wrapper } from './styled';

const ToolCell = ({ value }) => {
  return <Wrapper title={ value }>{value}</Wrapper>;
};

export default ToolCell;
